import { Button, LinkButton } from '@pmi/dsm-react';
import { memo } from 'react';
import styles from '../enhancedEnrollmentModal.module.scss';

interface AutoRenewFooterActionsProps {
  autoRenewButtonText: string;
  onRedeemNowAndRenewLater: () => void;
  onAutoRenewAction: () => void;
  disabled?: boolean;
}

function AutoRenewFooterActions({
  autoRenewButtonText,
  onRedeemNowAndRenewLater,
  onAutoRenewAction,
  disabled = false,
}: AutoRenewFooterActionsProps) {
  return (
    <>
      <hr className="my-4" />
      <div className="d-flex justify-content-between">
        <LinkButton
          size="sm"
          className={styles.leftButton}
          titleText="Redeem Now & Renew Later"
          onClick={onRedeemNowAndRenewLater}
          disabled={disabled}
        />
        <Button
          onClick={onAutoRenewAction}
          size="sm"
          titleText={autoRenewButtonText}
          disabled={disabled}
        />
      </div>
    </>
  );
}

export default memo(AutoRenewFooterActions);
